import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '官方认证',
    desc: '本站为www91官方认可的导航站点，所有入口地址均经过官方验证，确保安全可靠。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时更新',
    desc: '地址信息24小时监控更新，确保您获取的永远是最新可用的官方入口地址。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速访问',
    desc: '优化网络路由，提供多线路备选方案，保障您在任何网络环境下都能顺畅访问。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    desc: '提供详细的访问指南和使用教程，遇到问题还有常见问题解答帮您快速解决。',
  },
];

export default function TrustSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm max-w-[540px] mx-auto">
            作为www91官方认证导航站点，我们致力于为用户提供最可靠的访问指引
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200 transition-all duration-200"
            >
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                <i className={`${feature.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                {feature.title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-lg border border-primary-300 text-primary-700 hover:bg-primary-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-building-line w-4 h-4 flex items-center justify-center"></i>
            了解更多关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}